<template>
<div>
  <div v-if="!isMobile()">
    <Header/>
    <NFT/>
    <AboutUs/>
    <Why/>
    <MoreInfo/>
    <FinalDetails/>
  </div>

  <div v-if="isMobile()">
    <mobileHeader/>
    <mobileNFT/>
    <mobileAbout/>
    <mobileWhy/>
    <mobileBullets/>
    <mobileLocation/>
    <mobileTeam/>
    <mobileExpansion/>
    <mobilePlan/>
  </div>

  
  <Footer/>
  
</div>
</template>

<script>
import Header from './Desktop/Header.vue'
import NFT from './Desktop/NFT.vue'
import AboutUs from './Desktop/AboutUs.vue'
import Why from './Desktop/Why.vue'
import MoreInfo from './Desktop/MoreInfo.vue'
import FinalDetails from './Desktop/FinalDetails'
import Footer from './Navigation/Footer.vue'


import mobileHeader from './Mobile/Header.vue'
import mobileAbout from './Mobile/About.vue'
import mobileWhy from './Mobile/Why.vue'
import mobileBullets from './Mobile/Bullets.vue'
import mobileLocation from './Mobile/Location.vue'
import mobileTeam from './Mobile/Team.vue'
import mobileExpansion from './Mobile/Expansion.vue'
import mobileNFT from './Mobile/NFT.vue'
import mobilePlan from './Mobile/Plan.vue'

export default {
  mounted()
  {
    document.addEventListener('contextmenu', event => event.preventDefault());
  },
  components:{
    Header,
    NFT,
    AboutUs,
    Why,
    MoreInfo,
    FinalDetails,
    Footer,


    mobileHeader,
    mobileNFT,
    mobileAbout,
    mobileWhy,
    mobileBullets,
    mobileLocation,
    mobileTeam,
    mobileExpansion,
    mobilePlan
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Home.vue